/* PF Cart Drawer — behaviour
 * - open / close, body lock
 * - qty / remove / protection toggle via Cart AJAX API
 * - re-render of Liquid parts via Section Rendering API
 * - dynamic upsells (same finish, missing category), client-side
 */
(function () {
  var root = document.querySelector('[data-pfc]');
  if (!root || root.dataset.pfcInit) return;
  root.dataset.pfcInit = '1';

  var cfg = root.dataset;
  var sectionId = cfg.sectionId;
  var rootUrl = cfg.rootUrl || '/';
  var cartCache = null;
  var productCache = {};
  var lastUpsellKey = '';
  // Co-purchase map (assets/pf-upsell-map.json): { handle: [handle, ...] } ordered by how often bought together
  var upsellMap = null;
  var upsellMapPromise = cfg.upsellMapUrl ? fetch(cfg.upsellMapUrl).then(function (r) { return r.ok ? r.json() : {}; }).then(function (m) { upsellMap = m || {}; return upsellMap; }).catch(function () { upsellMap = {}; return upsellMap; }) : Promise.resolve({});

  /* ---------- open / close ---------- */
  function open() {
    if (root.classList.contains('is-open')) return;
    root.classList.add('is-open');
    document.body.classList.add('pfc-lock');
    setTimeout(function () { root.classList.add('is-visible'); }, 20);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-visible');
    document.body.classList.remove('pfc-lock');
    setTimeout(function () { root.classList.remove('is-open'); }, 320);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pfc-open], a[href="/cart"], a[href$="/cart"], .action__cart');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    refresh().then(open);
  });

  /* ---------- helpers ---------- */
  // Formats cents with the store's money format (shop.money_format), e.g. "€{{amount_with_comma_separator}}"
  function money(cents) {
    var fmt = cfg.moneyFormat || '{{amount}}';
    var n = cents / 100;
    function grp(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var out;
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) out = fmt.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grp(String(Math.round(n)), '.'));
    else if (fmt.indexOf('amount_with_comma_separator') !== -1) { var p = n.toFixed(2).split('.'); out = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, grp(p[0], '.') + ',' + p[1]); }
    else if (fmt.indexOf('amount_with_apostrophe_separator') !== -1) { var q = n.toFixed(2).split('.'); out = fmt.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, grp(q[0], "'") + '.' + q[1]); }
    else if (fmt.indexOf('amount_no_decimals') !== -1) out = fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, grp(String(Math.round(n)), ','));
    else { var r = n.toFixed(2).split('.'); out = fmt.replace(/\{\{\s*amount\s*\}\}/, grp(r[0], ',') + '.' + r[1]); }
    return out.replace(/<[^>]+>/g, '');
  }
  function busy(on) { root.classList.toggle('is-busy', !!on); }

  function fetchCart() {
    return fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; });
  }

  /* Re-render Liquid parts from the Section Rendering API */
  function rerender() {
    var url = rootUrl + '?sections=' + encodeURIComponent(sectionId) + '&_=' + Date.now();
    return fetch(url).then(function (r) { return r.json(); }).then(function (json) {
      var html = json[sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-pfc-part]').forEach(function (fresh) {
        var name = fresh.getAttribute('data-pfc-part');
        var cur = root.querySelector('[data-pfc-part="' + name + '"]');
        if (cur) cur.replaceWith(fresh);
      });
      var freshFoot = doc.querySelector('[data-pfc-foot]');
      var foot = root.querySelector('[data-pfc-foot]');
      if (freshFoot && foot) foot.hidden = freshFoot.hidden;
      bindParts();
    });
  }

  // Item count shown in header badge + drawer title: excludes the protection line
  function visibleCount(cart) {
    var protId = String(cfg.protectionId || '0');
    return cart.items.reduce(function (n, i) { return String(i.product_id) === protId ? n : n + i.quantity; }, 0);
  }

  function updateBadges(count) {
    document.querySelectorAll('[data-pfc-count]').forEach(function (el) {
      el.setAttribute('data-count', count);
      var inner = el.querySelector('span');
      if (inner) inner.textContent = count; else el.textContent = count;
    });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = count; });
  }

  function refresh() {
    busy(true);
    return Promise.all([fetchCart(), rerender()]).then(function (res) {
      var cart = res[0];
      updateBadges(visibleCount(cart));
      renderUpsells(cart);
    }).catch(function (e) { console.warn('[pf-cart]', e); }).then(function () { busy(false); });
  }

  /* ---------- cart mutations ---------- */
  function change(key, qty) {
    busy(true);
    return fetch(rootUrl + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-PFC': '1' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refresh(); });
  }
  function add(variantId, qty, props) {
    busy(true);
    var payload = { items: [{ id: variantId, quantity: qty || 1 }] };
    if (props) payload.items[0].properties = props;
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-PFC': '1' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function () { return refresh(); });
  }

  function bindParts() {
    root.querySelectorAll('[data-pfc-qty]').forEach(function (btn) {
      btn.onclick = function () {
        var key = btn.getAttribute('data-pfc-qty');
        var delta = parseInt(btn.getAttribute('data-pfc-delta'), 10);
        var line = cartCache && cartCache.items.find(function (i) { return i.key === key; });
        var q = (line ? line.quantity : 1) + delta;
        change(key, Math.max(0, q));
      };
    });
    root.querySelectorAll('[data-pfc-remove]').forEach(function (btn) {
      btn.onclick = function () { change(btn.getAttribute('data-pfc-remove'), 0); };
    });
    var prot = root.querySelector('[data-pfc-protection]');
    if (prot) {
      prot.onchange = function () {
        var vid = cfg.protectionVariant;
        if (!vid || vid === '0') return;
        if (prot.checked) {
          add(vid, 1, { _pf_protection: 'yes' });
        } else {
          var line = cartCache && cartCache.items.find(function (i) { return String(i.variant_id) === String(vid); });
          if (line) change(line.key, 0);
        }
      };
    }
    root.querySelectorAll('[data-pfc-close]').forEach(function (el) { el.onclick = function (e) { if (el.tagName !== 'A') e.preventDefault(); close(); }; });
  }

  /* ---------- upsells ---------- */
  var CATS = { bracelet: /bracelet|cuff|bangle/i, necklace: /necklace|chain|pendant/i, ring: /(^|[^a-z])ring/i };
  var PLURAL = { bracelet: 'bracelets', necklace: 'necklaces', ring: 'rings' };
  function classify(p) {
    var text = [p.title, p.product_type, (p.tags || []).join(' ')].join(' ');
    var cat = null;
    if (CATS.bracelet.test(text)) cat = 'bracelet';
    else if (CATS.necklace.test(text)) cat = 'necklace';
    else if (CATS.ring.test(text) && !/earring/i.test(text)) cat = 'ring';
    var finish = /gold/i.test(text) ? 'gold' : (/silver|steel|titanium|platinum/i.test(text) ? 'silver' : null);
    return { cat: cat, finish: finish };
  }
  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(rootUrl + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return productCache[handle];
  }
  function collectionHandles(handle) {
    return fetch(rootUrl + 'collections/' + handle + '/products.json?limit=12').then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(function (p) { return p.handle; }); }).catch(function () { return []; });
  }
  function recommendationHandles(productId, intent) {
    return fetch(rootUrl + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=' + (intent || 'related')).then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).map(function (p) { return p.handle; }); }).catch(function () { return []; });
  }

  function renderUpsells(cart) {
    var box = root.querySelector('[data-pfc-upsells]');
    var row = root.querySelector('[data-pfc-upsell-row]');
    var titleEl = root.querySelector('[data-pfc-upsell-title]');
    if (!box || !row) return;
    var protId = String(cfg.protectionId || '0');
    var lines = cart.items.filter(function (i) { return String(i.product_id) !== protId && !i.gift_card; });
    if (!lines.length) { box.hidden = true; return; }

    var key = lines.map(function (i) { return i.product_id; }).sort().join(',');
    if (key === lastUpsellKey && row.children.length) { box.hidden = false; return; }
    lastUpsellKey = key;

    var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var pattern = cfg.upsellCollections || '{finish}-{category}';
    var SLOTS = 6; // 1-2 bought together, 3-4 other categories, 5-6 bought together / fits the cart

    function interleave(lists, seen, order) {
      var maxLen = Math.max.apply(null, lists.map(function (l) { return l.length; }).concat([0]));
      for (var i = 0; i < maxLen; i++) lists.forEach(function (l) { if (l[i] && !seen[l[i]]) { seen[l[i]] = true; order.push(l[i]); } });
    }

    Promise.all(lines.map(function (l) { return getProduct(l.handle); }).concat([upsellMapPromise])).then(function (res) {
      var products = res.slice(0, -1).filter(Boolean);
      var map = res[res.length - 1] || {};
      var catsInCart = {}; var finishes = {};
      products.forEach(function (p) { var c = classify(p); if (c.cat) catsInCart[c.cat] = true; if (c.finish) finishes[c.finish] = true; });
      var finish = Object.keys(finishes)[0] || null;
      var missing = ['necklace', 'ring', 'bracelet'].filter(function (c) { return !catsInCart[c]; });

      // Pool A: bought together (order history map), then Shopify related/complementary
      var dataLists = lines.map(function (l) { return map[l.handle] || []; });
      var recPromises = [];
      products.forEach(function (p) { recPromises.push(recommendationHandles(p.id, 'related')); recPromises.push(recommendationHandles(p.id, 'complementary')); });
      // Pool B: one collection per category that is not in the cart, same finish when known
      var catPromises = missing.map(function (c) { return collectionHandles(finish ? pattern.replace('{finish}', finish).replace('{category}', PLURAL[c]) : PLURAL[c]); });
      var fallbackPromise = cfg.upsellFallback ? collectionHandles(cfg.upsellFallback) : Promise.resolve([]);

      return Promise.all([Promise.all(recPromises), Promise.all(catPromises), fallbackPromise]).then(function (r) {
        var seen = {}; var dataOrder = [];
        interleave(dataLists, seen, dataOrder);
        interleave(r[0], seen, dataOrder);
        var dataRank = {}; dataOrder.forEach(function (h, i) { dataRank[h] = i; });
        // category pools: items that are also bought together come first
        var catOrders = r[1].map(function (list) {
          return list.slice(0, 12).sort(function (a, b) { return (dataRank[a] === undefined ? 999 : dataRank[a]) - (dataRank[b] === undefined ? 999 : dataRank[b]); });
        });
        var all = dataOrder.slice(0, 14).concat(r[2].slice(0, 8));
        catOrders.forEach(function (l) { all = all.concat(l); });
        var uniq = []; var u = {}; all.forEach(function (h) { if (!u[h]) { u[h] = true; uniq.push(h); } });
        return Promise.all(uniq.map(getProduct)).then(function (objs) {
          var byHandle = {}; objs.forEach(function (p) { if (p) byHandle[p.handle] = p; });
          return { byHandle: byHandle, dataOrder: dataOrder, catOrders: catOrders, fallback: r[2], finish: finish, missing: missing };
        });
      });
    }).then(function (r) {
      var picks = [];
      var pickedIds = {};
      var finish = r.finish;
      function ok(p, wantCat) {
        if (!p || pickedIds[p.id] || inCart[p.id] || String(p.id) === protId) return false;
        if (finish) { var cf = classify(p).finish; if (cf && cf !== finish) return false; }
        if (wantCat && classify(p).cat !== wantCat) return false;
        if (/gift card/i.test(p.title) || /gift card/i.test(p.type || '')) return false;
        return !!p.available;
      }
      function take(handles, n, wantCat) {
        for (var i = 0; i < handles.length && n > 0; i++) {
          var p = r.byHandle[handles[i]];
          if (ok(p, wantCat)) { picks.push(p); pickedIds[p.id] = true; n--; }
        }
      }
      take(r.dataOrder, 2);                                              // slots 1-2
      // slots 3-4: one per missing category; a bought-together item of that category wins over the collection
      r.catOrders.forEach(function (list, i) { var before = picks.length; take(r.dataOrder, 1, r.missing[i]); if (picks.length === before) take(list, 1, r.missing[i]); });
      if (picks.length < 4 && r.catOrders[0]) take(r.catOrders[0], 4 - picks.length, r.missing[0]);
      take(r.dataOrder, SLOTS - picks.length);                           // slots 5-6
      if (picks.length < SLOTS) take(r.fallback, SLOTS - picks.length);
      r.catOrders.forEach(function (list) { if (picks.length < SLOTS) take(list, SLOTS - picks.length); });
      if (!picks.length) { box.hidden = true; return; }
      if (titleEl) titleEl.textContent = cfg.upsellHeading || 'Complete the look';
      row.innerHTML = picks.map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; });
        var first = v[0] || p.variants[0];
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x400$1$2') : '';
        var onSale = first.compare_at_price && first.compare_at_price > first.price;
        var price = money(first.price);
        var cmp = onSale ? '<s>' + money(first.compare_at_price) + '</s> ' : '';
        var tparts = p.title.split('|').map(function (x) { return x.trim(); });
        var title = tparts[0];
        var sub = tparts.slice(1).join(' · ');
        var sizes = '';
        if (v.length > 1) {
          sizes = '<div class="pfc__up-sizes" data-pfc-up-sizes><select class="pfc__up-select" data-pfc-up-select aria-label="Size"><option value="" selected disabled>' + (cfg.upsellSizeLabel || 'Size') + '</option>' +
            v.map(function (x) { return '<option value="' + x.id + '">' + x.title + '</option>'; }).join('') + '</select></div>';
        }
        return '<div class="pfc__up" data-pfc-up="' + p.id + '" data-pfc-up-single="' + (v.length > 1 ? '' : first.id) + '">' +
          '<div class="pfc__up-media">' +
            '<a class="pfc__up-img" href="' + rootUrl + 'products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
            '<button type="button" class="pfc__up-plus" aria-label="Add to cart" data-pfc-up-add>+</button>' +
            '<button type="button" class="pfc__up-hover" data-pfc-up-add>' + (cfg.upsellAddLabel || 'Add to cart') + '</button>' +
            sizes +
          '</div>' +
          '<div class="pfc__up-title">' + title + '</div>' +
          (sub ? '<div class="pfc__up-sub">' + sub + '</div>' : '') +
          '<div class="pfc__up-price">' + cmp + '<span class="' + (onSale ? 'pfc__up-price-sale' : '') + '">' + price + '</span></div>' +
          '</div>';
      }).join('');
      box.hidden = false;
      row.querySelectorAll('[data-pfc-up-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('[data-pfc-up]');
          var single = card.getAttribute('data-pfc-up-single');
          if (single) { markAdded(card); add(single, 1); return; }
          // multi-variant: show the size dropdown over the image
          row.querySelectorAll('.pfc__up.is-picking').forEach(function (c) { if (c !== card) c.classList.remove('is-picking'); });
          card.classList.toggle('is-picking');
          var sel = card.querySelector('[data-pfc-up-select]');
          if (card.classList.contains('is-picking') && sel) { try { sel.focus(); if (sel.showPicker) sel.showPicker(); } catch (e) {} }
        });
      });
      row.querySelectorAll('[data-pfc-up-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var card = sel.closest('[data-pfc-up]');
          var vid = sel.value;
          if (!vid) return;
          card.classList.remove('is-picking');
          markAdded(card);
          add(vid, 1);
          sel.selectedIndex = 0;
        });
      });
      function markAdded(card) {
        card.classList.add('is-added');
        var h = card.querySelector('.pfc__up-hover'); if (h) h.textContent = cfg.upsellAddedLabel || 'Added';
        setTimeout(function () { card.classList.remove('is-added'); if (h) h.textContent = cfg.upsellAddLabel || 'Add to cart'; }, 1800);
      }
    }).catch(function (e) { console.warn('[pf-cart upsells]', e); box.hidden = true; });
  }

  /* ---------- express checkout: keep only the wallets from the section setting ---------- */
  function filterWallets() {
    var wrap = root.querySelector('[data-pfc-express]');
    if (!wrap) return;
    var keep = (wrap.getAttribute('data-wallets') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    if (!keep.length) return;
    var old = wrap.querySelector('shopify-accelerated-checkout-cart');
    if (!old || old.dataset.pfcFiltered) return;
    var cfgs;
    try { cfgs = JSON.parse(old.getAttribute('wallet-configs') || '[]'); } catch (e) { return; }
    var filtered = cfgs.filter(function (w) { return keep.indexOf(String(w.name).toLowerCase()) !== -1; });
    if (!filtered.length) return;
    var el = document.createElement('shopify-accelerated-checkout-cart');
    Array.prototype.forEach.call(old.attributes, function (a) { if (a.name !== 'wallet-configs') el.setAttribute(a.name, a.value); });
    el.setAttribute('wallet-configs', JSON.stringify(filtered));
    el.dataset.pfcFiltered = '1';
    Array.prototype.forEach.call(old.children, function (c) {
      var slot = (c.getAttribute('slot') || '').toLowerCase().replace(/[^a-z]/g, '');
      var ok = filtered.some(function (w) { return slot.indexOf(String(w.name).toLowerCase().replace(/[^a-z]/g, '')) !== -1; });
      if (ok) el.appendChild(c.cloneNode(true));
    });
    old.replaceWith(el);
  }
  filterWallets();

  /* ---------- listen to adds from product forms / other scripts ---------- */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(url) && !(init && init.headers && init.headers['X-PFC'])) {
      p.then(function (r) {
        if (!r.ok) return;
        var isAdd = /\/cart\/add/.test(url);
        refresh().then(function () { if (isAdd && cfg.autoOpen === 'true') open(); });
      }).catch(function () {});
    }
    return p;
  };
  document.addEventListener('cart:update', function () { refresh(); });

  bindParts();
  fetchCart().then(function (c) { updateBadges(visibleCount(c)); if (c.item_count) renderUpsells(c); });
})();